import { Component, Input, OnInit, inject, forwardRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BaseListeComponent } from '@classes/extends';
import { ClientSynchro, ListeSynchro, SyncService as SynchronisationService } from '@estel-numerique/galaclick-api';
import { CacheLowService, FiltreHelper, FiltresService, TypeFiltre } from '@estel-numerique/galaclick-core';
import { UtilDate, UtilService } from '@services/index';
import { Constantes } from '@services/util/constantes';
import { lastValueFrom } from 'rxjs';
import { FiltreGala } from '../composants/composants';
import { SelectFiltre } from '../composants/select/select.component';
import { NgClass } from '@angular/common';
import { CpIconSort, CpIconSyncOK } from '../composants/icons/icons.component';
import { AgentActiviteDirective } from '../directive/directive';
import { ButtonGalaSearchComponent } from '../composants/buttons/btn-gala-search/btn-gala-search.component';
import { PaginationV2Component } from '../composants/paginationV2/paginationV2.component';
import { DateTimeFormatPipe } from '../../services/util/pipe';
import { DialogGalaComponent } from '../composants/dialog-gala/dialog-gala.component';
import { MatButton } from '@angular/material/button';
import { InputGala } from '../composants/inputs/input.component';
import { MenuClientComponent } from '../composants/menu-context/menu-client/menu-client.component';
import { ButtonGalaComponent } from '../composants/buttons/btn-gala/btn-gala.component';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateService } from '@ngx-translate/core';

/**
  * Liste des analyses supplémentaires
  */
@Component({
    templateUrl: './listeSyncListe.component.html',
    imports: [FiltreGala, SelectFiltre, NgClass, CpIconSort, AgentActiviteDirective, forwardRef(() => IconEchange), CpIconSyncOK, ButtonGalaSearchComponent, PaginationV2Component, DateTimeFormatPipe]
})
export class ListeSyncListeComponent extends BaseListeComponent implements OnInit {
    private wsSynchro = inject(SynchronisationService);
    public filtresService = inject(FiltresService);
    private dialog = inject(MatDialog);

    public titre: string = this.translate.instant("APPSYNC.TITRE");
    public codeModule: string = Constantes.CodeOption.MSYNCHRO; // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)

    public headElements: { libelle: string, tri: string, sortable: boolean }[] = [];
    public filtreEchange: TypeFiltre<string>[];
    public filtreStatut: TypeFiltre<string>[];
    protected lgTrad: Record<string, string>;

    public checkCreer() {
        return false;
    }
    get listeElementsAff() {
        return this.getListeAffichee<ListeSynchro>();
    }
    constructor() {
        super();
        this.headElements = [
            { libelle: this.translate.instant("DEBUT") + " " + this.translate.instant("APPSYNC.SYNCHRO") + " ", tri: 'DEBSYNC', sortable: true },
            { libelle: this.translate.instant("FIN") + " " + this.translate.instant("APPSYNC.SYNCHRO") + " ", tri: 'FINSYNC', sortable: true },
            { libelle: this.translate.instant("AGENT") + " ", tri: 'AGENT.NOM', sortable: true },
            { libelle: this.translate.instant("TEL") + " ", tri: 'AGENT.TEL1', sortable: true },
            { libelle: this.translate.instant("ORGANISME") + " ", tri: 'AGENT.ORGANISME', sortable: true },
            { libelle: this.translate.instant("APPSYNC.VAPP") + " ", tri: 'VERSION', sortable: true },
            { libelle: this.translate.instant("APPSYNC.EXCH"), tri: '', sortable: false },
            { libelle: this.translate.instant("STATUT"), tri: 'SYNCHOK', sortable: true }
        ];
    }

    ngOnInit() {
        super.ngOnInit();
        this.init().catch(e => this.util.fErreur(e));

    }
    private async init() {
        try {
            this.util.showLoader();
            this.filtreEchange = this.filtresService.getFiltreTypeEchangeSynchro();
            this.filtreStatut = this.filtresService.getFiltreStatutSynchro();

            this.lgTrad = {
                DISPLAY: this.translate.instant("FILTERS.DISPLAY"),
                TYPEEXCH: this.translate.instant("FILTERS.TYPEEXCH")
            };
            const list = await lastValueFrom(this.wsSynchro.getSyncListe());
            this.fSetListeElements(list);
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }


    showListeSync(listesync: ListeSynchro) {
        this.dialog.open(ListeSyncDetailsComponent, { data: listesync });
    }

    protected filtrage() {
        let liste = this.getListeElements<ListeSynchro>();
        //On vérifie si tout les filtre sont a true ou false
        if (FiltreHelper.isFiltrageNecessaire(this.filtreEchange)) {
            const hasFiltreEnvoi = this.filtreEchange.find((f) => { return f.value === FiltreHelper.TypeEchangeSynchro.ENVOI; }).filtre === true;
            const hasFiltreReception = this.filtreEchange.find((f) => { return f.value === FiltreHelper.TypeEchangeSynchro.RECEPTION; }).filtre === true;

            liste = liste.filter((o: ListeSynchro) => {
                return ((hasFiltreEnvoi &&
                    (o.CLIENTS[0].MODULES[0].MODULE.ID != 23 && o.CLIENTS[0].MODULES[0].MODULE.ID != 16)) ||
                    (hasFiltreReception && (o.CLIENTS[0].MODULES[0].MODULE.ID == 23
                        || o.CLIENTS[0].MODULES[0].MODULE.ID == 16)));
            });
        }
        //On vérifie si tout les filtre sont a true ou false
        if (FiltreHelper.isFiltrageNecessaire(this.filtreStatut)) {
            const hasFiltreOK = this.filtreStatut.find((f) => { return f.value === FiltreHelper.StatutSynchro.OK; }).filtre === true;
            const hasFiltreNOTOK = this.filtreStatut.find((f) => { return f.value === FiltreHelper.StatutSynchro.NOTOK; }).filtre === true;

            liste = liste.filter((o: ListeSynchro) => {
                return ((hasFiltreOK && o.SYNCHOK == 1) || (hasFiltreNOTOK && o.SYNCHOK == 0));
            });
        }

        return liste;
    }

    /**
     * Télécharge l'inventaire en .csv au click sur export
     */
    public fClicExporter() {
        if (this.getListeFiltree<ListeSynchro>().length <= 0) {
            this.util.showToastWarning(this.translate.instant("EXPORTCSVNO"));
        } else {
            this.util.fConfirm(this.translate.instant("EXPORTCSV", { libelle: this.translate.instant("APPSYNC.SYNCH").toLowerCase() }), () => {
                const tabExport: { DEBSYNC: string, FINSYNC: string, AGENT: string, AGENTEL: string, ORGANISME: string, VAPP: string, EXCH: string, STATUT: string }[] = [{
                    DEBSYNC: this.translate.instant("DEBUT"),
                    FINSYNC: this.translate.instant("FIN"),
                    AGENT: this.translate.instant("AGENT"),
                    AGENTEL: this.translate.instant("TEL"),
                    ORGANISME: this.translate.instant("ORGANISME"),
                    VAPP: this.translate.instant("APPSYNC.VAPP"),
                    EXCH: this.translate.instant("APPSYNC.EXCH"),
                    STATUT: this.translate.instant("STATUT")
                }];
                // On transfert juste les données utilises dans le tableau pour export
                for (const elem of this.getListeFiltree<ListeSynchro>()) {
                    tabExport.push({
                        DEBSYNC: elem.DEBSYNC,
                        FINSYNC: (elem.FINSYNC != null) ? elem.FINSYNC : '',
                        AGENT: elem.AGENT.NOM + ' ' + elem.AGENT.PRENOM,
                        AGENTEL: elem.AGENT.TELA.INDICATIF + ' ' + elem.AGENT.TELA.NUMERO,
                        ORGANISME: elem.AGENT.LISTESIG[0].NOMSIG,
                        VAPP: elem.VERSION,
                        EXCH: this.translate.instant("APPSYNC." + elem.CLIENTS[0].MODULES[0].MODULE.CODE),
                        STATUT: String(elem.SYNCHOK),
                    });
                }

                // Nom du fichier = GALACLICK + inventaire + date time
                this.downloadCSV(tabExport, "GALACLICK_" + this.translate.instant("APPSYNC.SYNCH").toLowerCase() + "_" + UtilDate.getDate_time());
            });
        }
    }

    public checkExport() {
        return true;
    }
}


/**
  * Liste des analyses supplémentaires
  */
@Component({
    templateUrl: './listeSyncDetails.component.html',
    imports: [DialogGalaComponent, NgClass, CpIconSort, forwardRef(() => IconEchange), CpIconSyncOK, ButtonGalaSearchComponent, PaginationV2Component, MatButton, DateTimeFormatPipe]
})
export class ListeSyncDetailsComponent extends BaseListeComponent implements OnInit {
    private wsSynchro = inject(SynchronisationService);
    private dialog = inject(MatDialog);
    private dialogRef = inject<MatDialogRef<ListeSyncDetailsComponent>>(MatDialogRef);
    public data = inject<ListeSynchro>(MAT_DIALOG_DATA);

    public titre: string;
    public codeModule: string = Constantes.CodeOption.MSYNCHRO; // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)
    public headElements: { libelle: string, tri: string, sortable: boolean }[] = [];
    protected lgTrad: Record<string, string>;

    public idUtil: number;

    public checkCreer() {
        return false;
    }
    get listeElementsAff() {
        return this.getListeAffichee<ListeSynchro>();
    }
    constructor() {
        super();
        this.dialogRef.updateSize('1200px');
        this.headElements = [
            { libelle: this.translate.instant("DEBUT") + " " + this.translate.instant("APPSYNC.SYNCHRO") + " ", tri: 'DEBSYNC', sortable: true },
            { libelle: this.translate.instant("FIN") + " ", tri: 'FINSYNC', sortable: true },
            { libelle: this.translate.instant("APPSYNC.VAPP") + " ", tri: 'VERSION', sortable: true },
            { libelle: this.translate.instant("APPSYNC.VSYS") + " ", tri: 'VSYSTEME', sortable: true },
            { libelle: this.translate.instant("APPSYNC.EXCH") + " ", tri: '', sortable: false },
            { libelle: this.translate.instant("STATUT") + " ", tri: 'SYNCHOK', sortable: true },
        ];
        this.lgTrad = {
            RETOUR: this.translate.instant("RET"),
        };
    }

    ngOnInit() {
        super.ngOnInit();
        this.show(this.data).catch(e => this.util.fErreur(e));
    }

    private async show(listeSync: ListeSynchro) {
        if (listeSync.AGENT != null) {
            const stitre = this.translate.instant("APPSYNC.TITRE");
            if (listeSync.AGENT.LISTESIG[0].COAGCL != null) {
                this.titre = stitre + " " + this.translate.instant("DE") + " " + listeSync.AGENT.NOM + " " + listeSync.AGENT.PRENOM;
            } else {
                this.titre = stitre;
            }
        }
        this.idUtil = listeSync.AGENT.USRID;
        this.util.showLoader();
        try {
            const list: ListeSynchro[] = await lastValueFrom(this.wsSynchro.getSyncListeDetails(this.idUtil));
            this.fSetListeElements(list);
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }

    }

    public showDetails(listeSync: ListeSynchro) {
        this.dialog.open(SyncDetailsComponent, { data: listeSync });
    }

    public hideModal() {
        this.dialogRef.close();
    }
}


/**
  * Details de la synchro
  */
@Component({
    templateUrl: './syncDetails.component.html',
    imports: [DialogGalaComponent, InputGala, CpIconSyncOK, MenuClientComponent, ButtonGalaComponent, MatButton, DateTimeFormatPipe]
})
export class SyncDetailsComponent implements OnInit {
    private util = inject(UtilService);
    private wsSynchro = inject(SynchronisationService);
    public translate = inject(TranslateService);
    protected wsCacheLow = inject(CacheLowService);
    private dialogRef = inject<MatDialogRef<SyncDetailsComponent>>(MatDialogRef);
    public data = inject<ListeSynchro>(MAT_DIALOG_DATA);

    public titre: string;
    protected lgTrad: Record<string, string>;
    public synchro: ListeSynchro;
    public cheptel: ClientSynchro & { SHOW?: boolean };
    //TODO passer les recup d'ID module en code
    //Tableau contenant le libellé correspondant au type denvoi du module par rapport à son ID
    public tNBUP = new Map<number, string>([
        [20, "commande(s)"],
        [13, "commande(s)"],
        [10, "exemple"]
    ]);
    public tNBUP2 = new Map<number, string>([
        [20, "analyse(s)"],
        [13, "analyse(s)"],
        [10, "exemple"]
    ]);

    constructor() {
        this.dialogRef.updateSize('60vw');
    }

    public ngOnInit() {
        this.lgTrad = {
            NAME: this.translate.instant("NAME"),
            SURNAME: this.translate.instant("SURNAME"),
            AGENTCODE: this.translate.instant("APPUTILISATEUR.SIG.AGENTCODE"),
            ORGANISME: this.translate.instant("ORGANISME"),
            DEBSYNC: this.translate.instant("DEBUT") + " " + this.translate.instant("APPSYNC.SYNCHRO"),
            FINSYNC: this.translate.instant("FIN") + " " + this.translate.instant("APPSYNC.SYNCHRO"),
            RETOUR: this.translate.instant("RET"),
        };
        this.show(this.data).catch(e => this.util.fErreur(e));
    }

    private async show(listeSync: ListeSynchro) {
        this.util.showLoader();
        try {
            this.synchro = null;
            this.cheptel = null;
            this.synchro = await lastValueFrom(this.wsSynchro.getSyncDetails(listeSync.AGENT.USRID, listeSync.IDSYNC));
        } catch (e) {
            this.util.fErreur(e);
        }
        this.util.hideLoader();
    }

    public showModules(elev: ClientSynchro) {
        //Si c'est le meme cheptel on le cache
        if (this.cheptel?.SHOW == true && this.cheptel.IDELEVSYNC == elev.IDELEVSYNC) {
            this.cheptel.SHOW = false;
        } else {
            //on cache le heptel actif
            if (this.cheptel != null) {
                this.cheptel.SHOW = false;
            }
            //on met en place le cheptel actif
            this.cheptel = elev;
            this.cheptel.SHOW = true;
        }
    }
    public hideModal() {
        this.dialogRef.close();
    }
}

@Component({
    selector: 'sync-icon-echange',
    styleUrls: ['./listesync.component.css'],
    template: `
        <span  matTooltip="{{LIB}}">
            <i [class]="(CODE === 'INV' || CODE === 'TRN')? 'fa fa-download':
                        (CODE === 'BGE')? 'fas fa-business-time':
                        (CODE === 'ANA' || CODE === 'PES'  || CODE === 'HUB')? 'fas fa-upload':'fas fa-question fa-lg'"
                aria-hidden="true"> </i>
        </span> `,
    imports: [MatTooltip]
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class IconEchange implements OnInit {
    @Input() synchro: ListeSynchro;
    protected CODE: string;
    protected LIB: string;

    constructor() { }

    ngOnInit() {
        //on verifie que l'objet synchro est complet
        if (this.synchro?.CLIENTS[0]?.MODULES[0]?.MODULE != null) {
            this.CODE = this.synchro.CLIENTS[0].MODULES[0].MODULE.CODE;
            this.LIB = this.synchro.CLIENTS[0].MODULES[0].MODULE.LIB;
        } else {
            //Si ce n'est pas le cas on affiche un point d'interrogation
            this.CODE = null;
            this.LIB = "Inconnu";
        }
    }
}
